export enum typeAlerts {
    EfficientPurchase = '2',
    Comparative = '1'
}